import { MonitoringErrorHandler } from 'monitoring-error-handler';
export const UnauthorizedEvent = 'unauthorized';
class AuthenticationInterceptor {
    static $inject = ['$rootScope', '$q', 'MESSAGINGHUBDOMAIN'];
    constructor($rootScope, $q, MESSAGINGHUBDOMAIN) {
        'ngInject';
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.responseError = this.responseError.bind(this);
        this._enabled = true;
        this.messaginghubDomain = this.extractDomain(this.MESSAGINGHUBDOMAIN);
    }
    enable() {
        this._enabled = true;
    }
    disable() {
        this._enabled = false;
    }
    responseError(res) {
        if (this._enabled &&
            res.status === 401 &&
            this.messaginghubDomain === this.extractDomain(res.config.url)) {
            this.$rootScope.$broadcast(UnauthorizedEvent);
        }
        this._enabled = true;
        MonitoringErrorHandler.instance.trackException({
            exception: res,
        });
        return this.$q.reject(res);
    }
    extractDomain(url) {
        let domain;
        //find & remove protocol (http, ftp, etc.) and get domain
        if (url.indexOf('://') > -1) {
            domain = url.split('/')[2];
        }
        else {
            domain = url.split('/')[0];
        }
        //find & remove port number
        domain = domain.split(':')[0];
        return domain;
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
AuthenticationInterceptor.$inject = ['$rootScope', '$q', 'MESSAGINGHUBDOMAIN'];
export default AuthenticationInterceptor;
